import { getQueryParam } from 'services/queryParamsService';

const MODE = 'mode';
const IFRAME_MODE = 'iframe';

const IframeModeMessages = {
  LOCATION: 'location',
  OPEN_SUPPORT_CHAT: 'open_support_chat',
}

function sendMessage(type: string, data: unknown) {
  window.parent.postMessage(JSON.stringify({ type, data }), '*');
}

let init = false;

export const IframeModeService = {
  init() {
    if (!init) {
      init = true;
    }
  },
  isIframeMode() {
    return getQueryParam(MODE) === IFRAME_MODE;
  },
  changeLocation(href: string) {
    sendMessage(IframeModeMessages.LOCATION, href);
  },
  openSupportChat(text: string) {
    sendMessage(IframeModeMessages.OPEN_SUPPORT_CHAT, text);
  },
};
